import { Divider } from 'semantic-ui-react';
import React from 'react';

import 'Styles/pages/vendorlinkintegration/preview.less';

const Spinner = () => {
  return (
    <React.Fragment>
      <Divider />
      <div id={'spinner'}>
        <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66">
          <circle
            className="path"
            fill="none"
            strokeWidth="6"
            strokeLinecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </React.Fragment>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/LoadingComponents/CircularSpinner.js